const LIST_URL = "/v1/announcement/list";
const SINGLE_URL = "/v1/announcement/single";
const ADD_URL = "/v1/announcement/add";
const UPDATE_URL = "/v1/announcement/update";
const DELETE_URL = "/v1/announcement/delete";

const ANNOUNCEMENT_API_URL_LIST = {
    LIST_URL,
    SINGLE_URL,
    ADD_URL,
    UPDATE_URL,
    DELETE_URL
}

export { ANNOUNCEMENT_API_URL_LIST };